// import { canUseDOM } from 'exenv';

export function companyAwardsLoading(resp = {}, store = {}) {
  return {
    type: 'COMPANY_AWARDS_LOADING',
    companyAwards: resp,
    store
  };
}

export function companyAwardsLoaded(resp = {}, store = {}) {
  return {
    type: 'COMPANY_AWARDS_LOADED',
    companyAwards: resp,
    store
  };
}

export function companyAwardsLoadError(error, store = {}) {
  return {
    type: 'COMPANY_AWARDS_ERROR',
    companyAwards: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store
  };
}
